import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShipmentService } from 'src/app/acumatica/EntityServices/Shipment.service';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';

@Component({
  selector: 'app-cut-hold-pull-get-shipment',
  templateUrl: './cut-hold-pull-get-shipment.component.html',
  styleUrls: ['./cut-hold-pull-get-shipment.component.css']
})
export class CutHoldPullGetShipmentComponent extends ApplicationScreen {
  pageTitle = "Pull Cut & Hold";
  shipmentNbrCtl = new FormControl();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private shipments: ShipmentService
  ) {
    super();
  }

  resetForInput() {
    this.shipmentNbrCtl.setValue(null);
    setTimeout(() => { (<any>this.shipmentNbrCtl).focus(); });
  }

  loadShipment(): void {
    const shipmentNbr = this.shipmentNbrCtl.value;
    if (!shipmentNbr) return;

    this.shipments.get(shipmentNbr).subscribe(shipment => {
      this.router.navigate(['/holdpull', shipment.ShipmentNbr]);
    })
  }

}
